import { Outlet } from "react-router-dom";

const LayoutNoNav = () => {
    return (
        <>
            <Outlet />
        </>
    );
}

export default LayoutNoNav
